interface CoinImageProps {
	width?: string | number;
	alt?: string;
	classes?: string;
}
/**
 * A React functional component that renders an image of a coin.
 *
 * @param {string} width - The width of the coin image (default: '25px').
 * @param {string} classes - Additional CSS classes to apply to the coin image.
 * @return {JSX.Element} The rendered coin image.
 */
export const CoinImage: React.FC<CoinImageProps> = ({
	width = '25px',
	alt = process.env.VITE_COIN_NAME,
	classes,
}: CoinImageProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<img
			src={process.env.VITE_COIN_IMAGE}
			className={`drop-shadow-lg ${classes}`}
			width={width}
			alt={alt}
		/>
	);
};
